import { DeliveryPackagesDataGrid } from "src/components/views/erp/delivery/deliveryPackage/DeliveryPackagesDataGrid.tsx";
import { useGlobalInitData } from "src/contexts/GlobalInitDataContext.ts";
import { DeliveryPackagesDataGridApi } from "src/api/generated/erp/delivery/api/deliveryPackagesDataGridApi.ts";

export interface CustomerDeliveryPackagesViewProps {
	customerId: number;
}

export const CustomerDeliveryPackagesView = ({ customerId }: CustomerDeliveryPackagesViewProps) => {
	const { defaultSiteId } = useGlobalInitData();

	return (
		<DeliveryPackagesDataGrid
			deliveryPackageSourceType={"CUSTOMER_ORDER"}
			gridId={"B9B7F47B78EC4969"}
			showSearchField
			showDeliveryStateSelection
			showSiteField
			defaultSiteId={defaultSiteId}
			fetchData={({ deliveryState: _deliveryState, customerId: _customerId, ...params }) =>
				DeliveryPackagesDataGridApi.getDeliveryPackagesForCustomer({
					...params,
					customerId,
				})
			}
		/>
	);
};
